export const availablePermissions = {
    "FAQ Management": true,
    "User Management": true,
    "CMS Management": true,
    "Category Management": true,
    "Auction Management": true,
    "Subadmin Management": true,
    "Email Template Management": true,
    "Bid Management": true,
    "Banner Management": true,
    "Customer Support Management": true,
    "Notification management": true,
    "Payment Management": true,
    "Vehicle Management": true
}